import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { FixedSizeGrid } from "react-window";
import ss from "./Backstage.module.css";
import Button from "../../components/Button";
import NavBack from "../../components/NavBack/NavBack";
import { GameModal } from "../../components/GameModal/GameModal";
import { QRCodeModalComponent } from "../../components/QRCodeModal/QRCodeModal";
import store from "../../store/store";
import {
  apiRequest,
  showLoading,
  showAlert,
  API_SERVER_URL,
  rem2px,
} from "../../utils";

export default function Backstage() {
  const navigate = useNavigate();
  const sessionUUID = new URLSearchParams(window.location.search).get(
    "session_uuid"
  );
  const [photoList, setPhotoList] = useState();
  // modal type: game_process, team_info, adjust_energy, failed_reason
  const gameModalType = useRef("");
  const [gameModalVisible, setGameModalVisible] = useState(false);
  const failedReasonType = useRef("");
  // 场次信息
  const [sessionInfo, setSessionInfo] = useState({});

  const getPhotoList = () => {
    // const loading = showLoading("加载中");
    apiRequest("/player_photo_list", "GET", {
      game_uuid: sessionUUID,
    }).then((res) => {
      if (res.code === 0) {
        setPhotoList(res.player_photos);
      } else {
        showAlert(res.msg);
      }
    });
    // .finally(() => {
    //   loading.hide();
    // });
  };

  const getSessionInfo = () => {
    // const loading = showLoading("加载中");
    apiRequest("/get_session_info", "GET", {
      session_uuid: sessionUUID,
    }).then((res) => {
      if (res.code === 0) {
        setSessionInfo(res.game_session);
        store.dispatch.gameSession.setStatus(res.game_session.status);
      } else {
        showAlert(res.msg);
      }
    });
    // .finally(() => loading.hide());
  };

  useEffect(() => {
    getSessionInfo(sessionUUID);
    store.dispatch.gameSession.setSessionUUID(sessionUUID);
    getPhotoList();

    // 建立SSE连接
    let eventSource = new EventSource(
      `${API_SERVER_URL}/subscribe_messages?device_id=${sessionUUID}`
    );
    // 监听消息
    const onMessage = (event) => {
      const message = JSON.parse(event.data);
      console.log("收到消息:", message);
      // 处理连接成功消息
      if (message.type === "connected") {
        console.log("SSE连接成功");
        return;
      } else if (
        message.type === "player_submit_task" ||
        message.type === "player_submit_rob" ||
        message.type === "player_submit_occupy_energy_hub" ||
        message.type === "player_submit_active_energy_hub" ||
        message.type === "photo_judge" ||
        message.type === "player_get_supply" ||
        message.type === "game_end"
      ) {
        getSessionInfo();
        getPhotoList();
      }
    };
    // 连接建立时的回调
    eventSource.onopen = () => {
      console.log("SSE连接已建立");
    };
    eventSource.onmessage = onMessage;
    // 错误处理
    eventSource.onerror = (error) => {
      console.error("SSE错误:", error);
      eventSource.close();

      // 3s后尝试重连
      setTimeout(() => {
        // Create a new EventSource connection
        eventSource = new EventSource(
          `${API_SERVER_URL}/subscribe_messages?device_id=${sessionUUID}`
        );
        // Re-attach event handlers
        eventSource.onmessage = onMessage;
      }, 3000);
    };
    // 在组件卸载时关闭连接
    return () => {
      if (eventSource) {
        eventSource.close();
        eventSource = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionUUID]);

  if (!photoList) return;

  const GridCell = ({ columnIndex, rowIndex, style }) => {
    let photoIdx = rowIndex * 4 + columnIndex;
    // 场次结束增加游戏结束卡片
    if (sessionInfo.status >= 200) {
      if (photoIdx === 0) {
        return <div className={ss.endCard}>游戏结束</div>;
      } else {
        photoIdx -= 1;
      }
    }
    const photo = photoList[photoIdx];
    if (!photo) return;
    return (
      <div
        className={classNames(ss.photoCard, photo.status > 1 && ss.judged)}
        key={photo.id}
        style={style}
      >
        <div
          className={classNames(
            ss.flag,
            sessionInfo.status >= 200 && ss.disabled
          )}
          style={{
            backgroundImage: `url(${require(`../img/flag${
              photo.status > 1 ? "_gray" : photo.team_color
            }.png`)})`,
          }}
          num={photo.team_color} // 索引从0开始，但编号从1开始
          width={1.67}
          onClick={() => {
            // 请求标记照片
            apiRequest("/mark_player_photo", "POST", {
              photo_id: photo.id,
              marked: photo.marked ? 0 : 1,
            }).then((res) => {
              if (res.code === 0) {
                // 修改 photo 状态，重新 render 这个元素
                photo.marked = !photo.marked;
                setPhotoList([...photoList]);
              } else {
                showAlert(res.msg);
              }
            });
          }}
        >
          <div className={classNames(ss.checkMark, photo.marked && ss.show)} />
        </div>
        <div className={ss.photoBox}>
          <img src={photo.photo} alt="" />
        </div>
        <div className={ss.photoInfo}>
          <div
            className={ss.taskDesc}
            dangerouslySetInnerHTML={{ __html: photo.task_desc }}
          ></div>
          <div className={ss.btnBar}>
            {photo.status < 2 && (
              <>
                <div
                  className={ss.photoBtn}
                  onClick={() => {
                    gameModalType.current = "failed_reason";
                    failedReasonType.current = photo.id;
                    setGameModalVisible(true);
                  }}
                >
                  失败
                </div>
                <div
                  className={ss.photoBtn}
                  onClick={() => {
                    // const loading = showLoading("加载中");
                    apiRequest("/check_player_photo", "POST", {
                      session_uuid: sessionUUID,
                      photo_id: photo.id,
                      success: 1,
                    }).then((res) => {
                      if (res.code === 0) {
                        getPhotoList();
                      } else {
                        showAlert(res.msg);
                      }
                    });
                    // .finally(() => {
                    //   loading.hide();
                    // });
                  }}
                >
                  成功
                </div>
              </>
            )}
            {photo.status === 2 && <>判定成功</>}
            {photo.status === 3 && <>判定失败：{photo.failed_reason_desc}</>}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={ss.bg}>
      <div className={ss.top}>
        <NavBack onClick={() => navigate("/Host")} />
        <Button
          title={"照片列表"}
          onClick={() => {
            navigate(`/photos?session_uuid=${sessionUUID}`);
            // Confirm.show("请确认是否关闭场次", () => {
            //   const loading = showLoading("加载中");
            //   apiRequest("/close_game_session", "POST", {
            //     session_uuid: sessionUUID,
            //   })
            //     .then((res) => {
            //       if (res.code === 0) {
            //         showAlert("关闭场次成功");
            //       } else {
            //         showAlert(res.msg);
            //       }
            //     })
            //     .catch((err) => console.log(err))
            //     .finally(() => loading.hide());
            // });
          }}
        />
        <Button
          title={"调整能量值"}
          onClick={() => {
            gameModalType.current = "change_energy";
            setGameModalVisible(true);
          }}
        />
        <Button
          title={"队伍信息"}
          onClick={() => {
            gameModalType.current = "team_info";
            setGameModalVisible(true);
          }}
        />
        <Button
          title={"游戏流程"}
          onClick={() => {
            gameModalType.current = "game_process";
            setGameModalVisible(true);
          }}
        />
      </div>

      <div className={ss.photoList}>
        <FixedSizeGrid
          columnCount={4} // 列数
          columnWidth={rem2px(466 + 36)} // 列宽
          height={rem2px(1356)} // 网格高度
          rowCount={Math.floor(photoList.length / 4) + 1} // 行数
          rowHeight={rem2px(844 + 50)} // 行高
          width={rem2px(2048)} // 网格宽度
          overscanColumnCount={4}
          overscanRowCount={1}
        >
          {GridCell}
        </FixedSizeGrid>
      </div>
      <GameModal
        visible={gameModalVisible}
        type={gameModalType.current}
        onClose={() => setGameModalVisible(false)}
        onConfirm={(value) => {
          if (gameModalType.current === "failed_reason") {
            const loading = showLoading("加载中");
            apiRequest("/check_player_photo", "POST", {
              session_uuid: sessionUUID,
              photo_id: failedReasonType.current,
              success: 0,
              failed_reason: value,
            })
              .then((res) => {
                if (res.code === 0) {
                  getPhotoList();
                } else {
                  showAlert(res.msg);
                }
              })
              .finally(() => {
                loading.hide();
              });
          } else if (gameModalType.current === "change_energy") {
            console.log(value);
            const loading = showLoading("加载中");
            apiRequest("/adjust_team_energy", "POST", {
              tid: value.teamUUID,
              type: value.changeType,
              energy: value.energyNum,
            })
              .then((res) => {
                if (res.code === 0) {
                  showAlert("调整能量值成功");
                } else {
                  showAlert(res.msg);
                }
              })
              .catch((err) => showAlert("请求失败，请稍后重试", err.message))
              .finally(() => {
                loading.hide();
              });
          }
        }}
      />
      <QRCodeModalComponent />
    </div>
  );
}
